import { validate } from 'utils/registration/formUtils';
import { Row, Col, Card, Input, Form, Divider, Alert, Upload, Checkbox, Icon, Button } from 'antd';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { dodAuthConfig } from './formConfig';

const
config = dodAuthConfig,
{ key } = config,
{ generateFormItem, generateInputComponent } = ssFormUtils,
{ validateForm, validateSubForm } = ssFormValidationUtils;

export default class DodAuthorization extends React.Component {
    state = { removeLetterIndicator: (
        <div style={{ display: 'inline' }}>
            <Icon type='paper-clip' />
            {' '}
        </div>
    )}

    constructor(props) { super(props); }

    getFormField(props, t) {
        const { dodAuthorizationUpdateField } = this.props.services;
        let input = null;
        switch(t) {
            case 'upload':
                const
                { letter } = this.props.state.forms.designeeLetter,
                indicator = this.state.removeLetterIndicator;
                input = (
                    <Upload
                        fileList={letter != null ? [ letter ] : []}
                        accept={'.pdf,.png,.jpg,.gif'}
                        showUploadList={false}
                        multiple={false}
                        beforeUpload={f => validate(
                            {...props, field: {...props.field, value: f }},
                            dodAuthorizationUpdateField
                        )}
                    >
                        <Button {...props.field} disabled={letter != null ? true : false}>
                            <Icon type='upload' />
                            {' Upload Letter'}
                        </Button>
                        {letter == null ? null : (
                            <div
                                style={{
                                    position: 'absolute',
                                    width: '260%',
                                    overflow: 'auto',
                                    marginTop: '5px',
                                    height: '20px'
                                }}
                                onMouseOver={() => {
                                    this.setState({...this.state,
                                        removeLetterIndicator: (
                                            <div style={{ display: 'inline' }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    validate(
                                                        {...props},
                                                        dodAuthorizationUpdateField
                                                    );
                                                }}
                                            >
                                                <Icon
                                                    type='close-circle'
                                                    style={{ zIndex: 5 }}
                                                />{' '}
                                            </div>
                                        )
                                    });
                                }}
                                onMouseOut={() => {
                                    this.setState({...this.state,
                                        removeLetterIndicator: (
                                            <div style={{ zIndex: 5, display: 'inline' }}>
                                                <Icon type='paper-clip' />{' '}
                                            </div>
                                        )
                                    });
                                }}
                            >
                                {indicator}
                                {` ${letter.name} `}
                            </div>
                        )}
                    </Upload>
                );
                break;
        }

        return (
            <Form.Item {...props.form} style={{ height: '110px', overflow: 'hidden' }}>
                {input}
            </Form.Item>
        );
    }

    handleTitleUpdate(prev) {
        const
        { services, utils, state } = this.props,
        s = services.dodAuthorizationUpdateTitle,
        p = prev.state.status,
        c = state.status;

        utils.updateTitle(6, 'edit', s, p, c);
    }

    componentDidUpdate(prevProps) {
        this.handleTitleUpdate(prevProps);

        const
        { services, registrationForm } = this.props,
        currForm = registrationForm[key],
        prevForm = prevProps.registrationForm[key],
        { storeForm } = services;

        if(!ssCommonUtils.simpleObjectCompare(prevForm, currForm)) {
            const formState = validateForm(currForm, config, true);
            storeForm(key, formState);
            this.setState({ isValid: validateSubForm(formState) });
        }
    }

    render() {
        const
        f = this.props.state.forms,
        { services, registrationForm } = this.props,
        { storeFormField, storeForm } = services,
        form = registrationForm[key];
        return (
            <div>
                <Row type='flex' justify='center' style={{ marginBottom: '20px' }}>
                    <Col span={20}>
                        <Card
                            hoverable
                            bodyStyle={{ padding: '0 20px 20px 20px' }}
                            style={{ cursor: 'default' }}
                        >
                            <Divider>
                                <span style={{ fontSize: '14px', fontStyle: 'italic', fontWeight: 'bold', color: 'rgb(53, 158, 255)' }}>
                                    {'Authorization Notice'}
                                </span>
                            </Divider>
                            <div style={{ marginTop: '-10px' }}>
                                <span style={{ fontWeight: 'bold' }}>
                                    {'Title 18 Section 1001 of the U.S. Code provides that knowingly falsifying or '}
                                    {'concealing a material fact is a felony that may result in fines of up to $10,000 '}
                                    {'or 5 years in prison or both. By submitting this form, you are certifying that '}
                                    {'the information provided herein is true and complete to the best of your knowledge '}
                                    {'and ability.'}
                                </span>
                            </div>
                            <div style={{ marginTop: '15px' }}>
                                <Alert message={(
                                    <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
                                        {'I hereby declare under penalty of perjury that the information contained on '}
                                        {'this form is true and correct.'}
                                    </span>
                                )} />
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row type='flex' justify='center'>
                    <Col span={23}>
                        <Row type='flex' justify='center' gutter={12}>
                            <Col span={6} offset={2}>
                                <Form.Item {...generateFormItem('signature', config, form)} style={{ overflow:'hidden' }}>
                                    <Input {...{...generateInputComponent('signature', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item {...generateFormItem('agree', config, form)} style={{overflow:'hidden'}}>
                                    <Checkbox {...generateInputComponent('agree', config, true, form, storeFormField, storeForm)}/>
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                {this.getFormField(f.designeeLetter, 'upload')}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}
